import { Grid, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Title } from "capitalrx-components-2.0/lib/typography";

import { useSelectedEnrollmentPlan } from "@/premium/hooks";
import { useIsMedicarePartD } from "@/premium/hooks/useHasMedicarePlans";
import { DocumentsPanel } from "@/premium/pages/PlanDetailsPage/DocumentsPanel";
import { FormularyPanel } from "@/premium/pages/PlanDetailsPage/FormularyPanel";
import { MedicarePrescriptionPaymentPlanPanel } from "@/premium/pages/PlanDetailsPage/MedicarePrescriptionPaymentPlanPanel";
import { PharmaciesAndPricingPanel } from "@/premium/pages/PlanDetailsPage/PharmaciesAndPricingPanel";
import { Breadcrumbs, PageLayout } from "@/premium/themedComponents";

export const PlanDetailsPage = () => {
  const { enrollmentPlanCsid, hideFormularyLookup, hidePharmacySearch, hideMedicarePrescriptionPaymentPlanPage, hidePlanDocuments } = useSelectedEnrollmentPlan();

  const { leftColumns, rightColumns } = useResponsive({
    leftColumns: {
      desktop: 5,
      tablet: 6,
      mobile: 12,
    },
    rightColumns: {
      desktop: 7,
      tablet: 6,
      mobile: 12,
    },
  });

  const isMedicarePlan = useIsMedicarePartD(enrollmentPlanCsid?.id);

  return (
    <PageLayout>
      <Stack spacing="large">
        <Stack>
          <Breadcrumbs planName={enrollmentPlanCsid?.display_name} />
          <Title>{enrollmentPlanCsid?.display_name}</Title>
          <Grid>
            <Grid.Span columns={leftColumns}>
              <Stack>
                {!hidePharmacySearch && <PharmaciesAndPricingPanel />}
                {!hideFormularyLookup && <FormularyPanel />}
                {!hideMedicarePrescriptionPaymentPlanPage && isMedicarePlan && <MedicarePrescriptionPaymentPlanPanel />}
              </Stack>
            </Grid.Span>
            {!hidePlanDocuments && (
              <Grid.Span columns={rightColumns}>
                <DocumentsPanel />
              </Grid.Span>
            )}
          </Grid>
        </Stack>
      </Stack>
    </PageLayout>
  );
};
